module.exports = __webpack_public_path__ + "fonts/iconfont.f4d8f472.ttf";